import { render, staticRenderFns } from "./exercise.vue?vue&type=template&id=060c6a70&scoped=true&"
import script from "./exercise.vue?vue&type=script&lang=ts&"
export * from "./exercise.vue?vue&type=script&lang=ts&"
import style0 from "./exercise.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exercise.vue?vue&type=style&index=1&id=060c6a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c6a70",
  null
  
)

export default component.exports